<div class="content-without-stepper-and-title document-introduction" *ngIf="is_loading_complete">
  <div class="row">
    <div class="col-4 col-pr-12 col-sm-8 col-md-12 col-lg-12 col-xl-12">
      <div class="image">
        <img id="docIntroImg" src="assets/images/check_data.png" alt="{{copyService.copies.document_introduction_alt_image}}" />
      </div>
      <div id="docIntroTitle" class="title">{{copyService.copies.update_data_title}} {{ documentInfo.firstname }}!</div>
      <div *ngIf="!mandatoryUpdate" id="docIntroTitle" class="subtitle">{{copyService.copies.update_data_subtitle}} </div>
      <div *ngIf="mandatoryUpdate" id="docIntroTitle" class="subtitle"> {{ copyService.copies.update_data_subtitle_two }} </div>
    </div>
  </div>
  <app-controls *ngIf="mandatoryUpdate" id="docIntroBtns" [nextLabel]="copyService.copies.update_data_button" (previous)="nextNo()" (next)="nextYes()"></app-controls>
  <app-controls *ngIf="!mandatoryUpdate" id="docIntroBtns" [hasPrevious]="true" [nextLabel]="copyService.copies.update_data_button_no" [previousLabel]="copyService.copies.update_data_button_yes"  (previous)="nextYes()" (next)="nextNo()"></app-controls>
</div>
